import { useDataFetchIndicator } from '..';
import * as vp from 'vopay';
import vopayApi from '../../services/api.config';
import { toBool } from 'vopay';
import { useClientData } from '@/providers/ClientData.provider';
import { useState } from 'react';

const initHook = vopayApi.withApiHook(({ api }) => {
  return function useFetchContactPaymentMethod() {
    const [, setDataFetchingInfo] = useDataFetchIndicator();
    const { response: loginUser } = useClientData();
    const clientAccountsEnabled = toBool(loginUser.ClientAccountsEnabled);
    const [paymentMethods, setPaymentMethods] = useState<vp.PaymentMethod[]>([]);

    return {
      paymentMethods,
      fetchPaymentMethods: async (accountID: string) => {
        try {
          setDataFetchingInfo(true);

          const resp = clientAccountsEnabled
            ? await api.fetchClientAccountPaymentMethods({
                ClientAccountID: accountID,
              })
            : await api.fetchContactPaymentMethods({
                ContactID: accountID,
              });
          setDataFetchingInfo(false);
          setPaymentMethods(resp.PaymentMethods || []);
          return resp;
        } finally {
          setDataFetchingInfo(false);
        }
      },
    };
  };
});

export default initHook({});
